<div class="tm-login-button">
    <button class="btn login-button" (click)="LoginToOAuthProvider()" value="Login">
        {{ 'fgbcl.registration.provider.oauth.login.button.text' | translate  }}
        <i id="provider-icon">
            <ticket-master-icon></ticket-master-icon>
        </i>
    </button>
</div>